import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Availability from './pages/Availability';
import Rooms from './pages/Rooms';
import Booking from './pages/Booking';
import Contact from './pages/Contact';
import RoomDetail from './pages/RoomDetail';



function App() {
  return (
    <Router>
      <Header />
      <div className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/availability" element={<Availability />} />
          <Route path="/rooms" element={<Rooms />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/room/:roomName" element={<RoomDetail />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
